/**
 * `restore-master-version` plan. Single atomic call on the BE
 * (`POST /api/v2/route/{routeId}/master/stops/restore`); the pipeline is
 * preflight + the one step + verify. Strategy-independent — `v1-bulk` reuses
 * this with its own strategy label since there's no separate v1-era endpoint
 * for restore.
 */
import type {
  Deps,
  OperationPlan,
  PipelineStep,
  RestoreMasterVersionIntent,
} from 'types/modules/routing'

import { makePreflightStep } from '../steps/preflight'
import { makeRestoreMasterVersionStep } from '../steps/restoreMasterVersion'
import { makeVerifyStep } from '../steps/verify'

const STRATEGY_ID = 'v2-pipeline' as const

export const buildRestoreMasterVersionPipeline = (
  intent: RestoreMasterVersionIntent,
  deps: Deps,
): OperationPlan => ({
  strategy: STRATEGY_ID,
  intent,
  steps: [
    makePreflightStep({ intent }, deps) as PipelineStep,
    makeRestoreMasterVersionStep(
      {
        routeId: intent.routeId,
        versionId: intent.versionId,
        syncFuture: intent.syncFuture,
        reassign: intent.reassign,
      },
      deps,
    ) as PipelineStep,
    makeVerifyStep({ intent }, deps) as PipelineStep,
  ],
})
